import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { TechnicalLetterService } from "../../services/technical-letters/technical-letter.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-letter-log",
    templateUrl: "./letter-log.component.html",
    standalone: false
})
export class LetterLogComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    "rowUpdatedDate",
    "rowUpdatedBy",
    "letterNumber",
    "letterTitle",
    "letterStatus",
    "letterCategory",
    "letterIssueDate",
    "letterUrl",
    "letterRecurringFlag",
  ];

  dataSource = new MatTableDataSource<any>([]);
  loading = false;
  error: string | null = null;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private technicalLetterService: TechnicalLetterService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const letterId = Number(this.route.snapshot.paramMap.get("letterId"));
    if (letterId) {
      this.technicalLetterService.getLetterHistory(letterId).subscribe({
        next: (data) => {
          this.dataSource.data = data;
          this.loading = false;
          if (this.paginator) {
            this.dataSource.paginator = this.paginator;
          }
        },
      });
    } else {
      this.error = "No letter ID provided.";
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }
}
